import {
  axios
} from '@/entry/templateCommon';
import Bridge from'@/frontend-lib/lib/Bridge'



// 判断环境
let HOST = getRunTime('//m.xinli001.com')
const UA = window.navigator.userAgent.toUpperCase()
const IS_APP = UA.indexOf('YIXINLIAPP') !== -1
function getRunTime(str) {
  let result
  let _href = window.location.href.split('.')[0]

  _href.replace(/-([A-Za-z0-9]*)/, (s, v) => {
    result = str.replace(/\./, `-${v}.`)
  })

  if (!result) {
    result = str
  }

  return result
}
export default options => {
  // 微信分享
  if (UA.toUpperCase().indexOf('MICROMESSENGER') !== -1) {
    let currentUrl = document.location.href
    let getWxConfig = `${HOST}/wx/get-wx-package.json`
    axios
      .get(getWxConfig + '?url=' + encodeURIComponent(currentUrl))
      .then(res => {
        if (res.data.code == 0) {
          var wxConfig = res.data.data
          function loadScript(url, callback) {
            var script = document.createElement('script')
            script.type = 'text/javascript'
            if (typeof callback !== 'undefined') {
              if (script.readyState) {
                script.onreadystatechange = function() {
                  if (
                    script.readyState == 'loaded' ||
                    script.readyState == 'complete'
                  ) {
                    script.onreadystatechange = null
                    callback()
                  }
                }
              } else {
                script.onload = function() {
                  callback()
                }
              }
            }
            script.src = url
            document.body.appendChild(script)
          }

          setTimeout(() => {
            loadScript('//res.wx.qq.com/open/js/jweixin-1.0.0.js', () => {
              var _config = {
                debug: wxConfig.debug,
                appId: wxConfig.appId,
                timestamp: wxConfig.timestamp,
                nonceStr: wxConfig.nonceStr,
                signature: wxConfig.signature,
                jsApiList: [
                  'onMenuShareTimeline',
                  'onMenuShareAppMessage',
                  'onMenuShareQQ',
                  'onMenuShareWeibo',
                  'onMenuShareQZone'
                ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              }

              // 微信基本配置信息
              wx.config(_config)

              wx.ready(function() {
                var shareConfig = options
                // {
                //   // title: window.baseInfo.wx_share_config.title,
                //   // desc: window.baseInfo.wx_share_config.desc,
                //   // link: window.baseInfo.wx_share_config.url,
                //   // imgUrl: window.baseInfo.wx_share_config.cover, // 图片地址
                //   success: function(res) {},
                //   cancel: function(res) {},
                //   fail: function(res) {}
                // }
                // 分享到朋友圈
                wx.onMenuShareTimeline(shareConfig)
                // 分享给朋友
                wx.onMenuShareAppMessage(shareConfig)
                // 分享到QQ
                wx.onMenuShareQQ(shareConfig)
                // 分享到腾讯微博
                wx.onMenuShareWeibo(shareConfig)
                // 分享到QQ空间
                wx.onMenuShareQZone(shareConfig)
              })
            })
          }, 500)
        }
      })
  }

  // APP分享
  if (IS_APP) {
    var myBrige = new Bridge({
      methods: [
        {
          method: 'topFuncBtn',
          callback: function(ops) {
            if (ops.name == 'shareReportBtn') {
              var share_config = options
              myBrige.call('shareReport', share_config)
            }
          }
        }
      ]
    })
    myBrige.call('topFuncBtnConfig', {
      btnList: [
        {
          name: 'shareReportBtn',
          visible: 1
        }
      ]
    })
  }
}



// WEBPACK FOOTER //
// ./src/util/share.js